function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

export { memoize as default };



//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/student-restrict-access/~/@emotion/memoize/dist/emotion-memoize.esm.js
// module id = I4e1
// module chunks = 0